module.exports = __webpack_public_path__ + "img/HM.c7ffb12b.png";